import React from 'react';
import { Container } from 'components/UI';
import IntroDefault from './IntroDefault';
import { getMeetupDateString } from 'utils';

import * as styles from './Intro.module.scss';

export default function Intro({ meetupDate, customDate, showDefaultIntro, ...props }) {
  const preparedProps = {
    ...props,
    date: customDate ?? getMeetupDateString(meetupDate),
  };

  return (
    <Container className={styles.container} background="transparent">
      <IntroDefault {...preparedProps} />
    </Container>
  );
}
